"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var isCreateSocketValid = function isCreateSocketValid(e) {
  return null != e;
},
    isHostValid = function isHostValid(e) {
  return "string" == typeof e && e && "" !== e;
},
    isPortValid = function isPortValid(e) {
  return "number" == typeof e && 1 <= e && e <= 65535;
},
    onCommandValid = function onCommandValid(e) {
  return "function" == typeof e;
},
    validate = function validate(e) {
  var n = e.createSocket,
      t = e.host,
      r = e.port,
      o = e.onCommand;
  if (!isCreateSocketValid(n)) throw new Error("invalid createSocket function");
  if (!isHostValid(t)) throw new Error("invalid host");
  if (!isPortValid(r)) throw new Error("invalid port");
  if (!onCommandValid(o)) throw new Error("invalid onCommand handler");
},
    logger = function logger() {
  return function (r) {
    return {
      features: {
        log: function log() {
          for (var e = [], n = 0; n < arguments.length; n++) {
            e[n] = arguments[n];
          }

          var t = e && 1 === e.length ? e[0] : e;
          r.send("log", {
            level: "debug",
            message: t
          }, !1);
        },
        logImportant: function logImportant() {
          for (var e = [], n = 0; n < arguments.length; n++) {
            e[n] = arguments[n];
          }

          var t = e && 1 === e.length ? e[0] : e;
          r.send("log", {
            level: "debug",
            message: t
          }, !0);
        },
        debug: function debug(e, n) {
          return void 0 === n && (n = !1), r.send("log", {
            level: "debug",
            message: e
          }, !!n);
        },
        warn: function warn(e) {
          return r.send("log", {
            level: "warn",
            message: e
          }, !0);
        },
        error: function error(e, n) {
          return r.send("log", {
            level: "error",
            message: e,
            stack: n
          }, !0);
        }
      }
    };
  };
},
    image = function image() {
  return function (a) {
    return {
      features: {
        image: function image(e) {
          var n = e.uri,
              t = e.preview,
              r = e.filename,
              o = e.width,
              i = e.height,
              s = e.caption;
          return a.send("image", {
            uri: n,
            preview: t,
            filename: r,
            width: o,
            height: i,
            caption: s
          });
        }
      }
    };
  };
},
    benchmark = function benchmark() {
  return function (i) {
    var s = i.startTimer;
    return {
      features: {
        benchmark: function benchmark(n) {
          var r = [],
              o = s(),
              t = function t(e) {
            var n = 0 === r.length ? 0 : r[r.length - 1].time,
                t = o();
            r.push({
              title: e,
              time: t,
              delta: t - n
            });
          };

          r.push({
            title: n,
            time: 0,
            delta: 0
          });

          var e = function e(_e) {
            t(_e), i.send("benchmark.report", {
              title: n,
              steps: r
            });
          };

          return {
            step: t,
            stop: e,
            last: e
          };
        }
      }
    };
  };
},
    stateResponses = function stateResponses() {
  return function (r) {
    return {
      features: {
        stateActionComplete: function stateActionComplete(e, n, t) {
          return void 0 === t && (t = !1), r.send("state.action.complete", {
            name: e,
            action: n
          }, !!t);
        },
        stateValuesResponse: function stateValuesResponse(e, n, t) {
          return void 0 === t && (t = !0), r.send("state.values.response", {
            path: e,
            value: n,
            valid: t
          });
        },
        stateKeysResponse: function stateKeysResponse(e, n, t) {
          return void 0 === t && (t = !0), r.send("state.keys.response", {
            path: e,
            keys: n,
            valid: t
          });
        },
        stateValuesChange: function stateValuesChange(e) {
          return r.send("state.values.change", {
            changes: e
          });
        },
        stateBackupResponse: function stateBackupResponse(e) {
          return r.send("state.backup.response", {
            state: e
          });
        }
      }
    };
  };
},
    apiResponse = function apiResponse() {
  return function (o) {
    return {
      features: {
        apiResponse: function apiResponse(e, n, t) {
          var r = !(n && n.status && "number" == typeof n.status && 200 <= n.status && n.status <= 299);
          o.send("api.response", {
            request: e,
            response: n,
            duration: t
          }, r);
        }
      }
    };
  };
},
    clear = function clear() {
  return function (e) {
    return {
      features: {
        clear: function clear() {
          return e.send("clear");
        }
      }
    };
  };
},
    UNDEFINED = "~~~ undefined ~~~",
    NULL = "~~~ null ~~~",
    FALSE = "~~~ false ~~~",
    ZERO = "~~~ zero ~~~",
    EMPTY_STRING = "~~~ empty string ~~~",
    CIRCULAR = "~~~ Circular Reference ~~~",
    ANONYMOUS = "~~~ anonymous function ~~~",
    INFINITY = "~~~ Infinity ~~~",
    NEGATIVE_INFINITY = "~~~ -Infinity ~~~";

function getFunctionName(e) {
  var n = e.name;
  return null == n || "" === n ? ANONYMOUS : "~~~ " + n + "() ~~~";
}

function serialize(e) {
  var r,
      o = [];
  return JSON.stringify(e, (r = null, function (e, n) {
    if (!0 === n) return !0;
    if (n === 1 / 0) return INFINITY;
    if (n === -1 / 0) return NEGATIVE_INFINITY;
    if (0 === n) return ZERO;
    if (void 0 === n) return UNDEFINED;
    if (null === n) return NULL;
    if (!1 === n) return FALSE;
    if (-0 === n) return ZERO;
    if ("" === n) return EMPTY_STRING;

    switch (typeof n) {
      case "string":
      case "number":
        return n;

      case "function":
        return getFunctionName(n);
    }

    if (0 < o.length) {
      var t = o.indexOf(this);
      ~t ? o.splice(t + 1) : o.push(this), ~o.indexOf(n) && (n = CIRCULAR);
    } else o.push(n);

    return null == r ? n : r.call(this, e, n);
  }));
}

var defaultPerformanceNow = function defaultPerformanceNow(e) {
  return Date.now();
},
    nativePerformance = "undefined" != typeof window && window && (window.performance || window.msPerformance || window.webkitPerformance),
    performanceNow = defaultPerformanceNow,
    delta = function delta(e) {
  return performanceNow() - e;
};

global.nativePerformanceNow ? performanceNow = global.nativePerformanceNow : nativePerformance && (performanceNow = function performanceNow() {
  return nativePerformance.now && nativePerformance.now();
});

var start = function start() {
  var e = performanceNow();
  return function () {
    return delta(e);
  };
},
    _assign = function __assign() {
  return (_assign = Object.assign || function (e) {
    for (var n, t = 1, r = arguments.length; t < r; t++) {
      for (var o in n = arguments[t]) {
        Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
      }
    }

    return e;
  }).apply(this, arguments);
},
    corePlugins = [image(), logger(), benchmark(), stateResponses(), apiResponse(), clear()],
    DEFAULT_OPTIONS = {
  createSocket: null,
  host: "localhost",
  port: 9090,
  name: "reactotron-core-client",
  secure: !1,
  plugins: corePlugins,
  safeRecursion: !0,
  onCommand: function onCommand(e) {
    return null;
  },
  onConnect: function onConnect() {
    return null;
  },
  onDisconnect: function onDisconnect() {
    return null;
  }
},
    reservedFeatures = ["options", "connected", "socket", "plugins", "configure", "connect", "send", "use", "startTimer"],
    isReservedFeature = function isReservedFeature(n) {
  return reservedFeatures.some(function (e) {
    return e === n;
  });
};

function emptyPromise() {
  return Promise.resolve("");
}

var Client = function () {
  function e() {
    var s = this;
    this.options = Object.assign({}, DEFAULT_OPTIONS), this.connected = !1, this.socket = null, this.plugins = [], this.sendQueue = [], this.isReady = !1, this.lastMessageDate = new Date(), this.customCommands = [], this.customCommandLatestId = 1, this.startTimer = function () {
      return start();
    }, this.send = function (e, n, t) {
      if (void 0 === n && (n = {}), void 0 === t && (t = !1), s.socket) {
        var r = new Date(),
            o = r.getTime() - s.lastMessageDate.getTime();
        o < 0 && (o = 0);
        var i = serialize({
          type: e,
          payload: n,
          important: !!t,
          date: (s.lastMessageDate = r).toISOString(),
          deltaTime: o
        });
        s.isReady ? s.socket.send(i) : s.sendQueue.push(i);
      }
    };
  }

  return e.prototype.configure = function (e) {
    var n = this;
    void 0 === e && (e = {});
    var t = Object.assign({}, this.options, e);
    return validate(t), this.options = t, Array.isArray(this.options.plugins) && this.options.plugins.forEach(function (e) {
      return n.use(e);
    }), this;
  }, e.prototype.close = function () {
    this.connected = !1, this.socket && this.socket.close && this.socket.close();
  }, e.prototype.connect = function () {
    var t = this;
    this.connected = !0;

    var e = this.options,
        n = e.createSocket,
        r = e.secure,
        o = e.host,
        i = e.environment,
        s = e.port,
        a = e.name,
        u = e.client,
        c = void 0 === u ? {} : u,
        f = e.getClientId,
        l = this.options,
        d = l.onCommand,
        m = l.onConnect,
        p = l.onDisconnect,
        h = n((r ? "wss" : "ws") + "://" + o + ":" + s),
        g = function g() {
      m && m(), t.plugins.forEach(function (e) {
        return e.onConnect && e.onConnect();
      }), (f || emptyPromise)().then(function (e) {
        for (t.isReady = !0, t.send("client.intro", _assign({
          environment: i
        }, c, {
          name: a,
          clientId: e,
          reactotronCoreClientVersion: "2.1.4"
        })); 0 < t.sendQueue.length;) {
          var n = t.sendQueue[0];
          t.sendQueue = t.sendQueue.slice(1), t.socket.send(n);
        }
      });
    },
        v = function v() {
      t.isReady = !1, p && p(), t.plugins.forEach(function (e) {
        return e.onDisconnect && e.onDisconnect();
      });
    },
        w = function w(e) {
      var n = JSON.parse(e);
      d && d(n), t.plugins.forEach(function (e) {
        return e.onCommand && e.onCommand(n);
      }), "custom" === n.type ? t.customCommands.filter(function (e) {
        return e.command === n.payload;
      }).forEach(function (e) {
        return e.handler();
      }) : "setClientId" === n.type && t.options.setClientId && t.options.setClientId(n.payload);
    };

    return h.on ? (h.on("open", g), h.on("close", v), h.on("message", w)) : (h.onopen = g, h.onclose = v, h.onmessage = function (e) {
      return w(e.data);
    }), this.socket = h, this;
  }, e.prototype.display = function (e) {
    void 0 === e && (e = {});
    var n = e.name,
        t = e.value,
        r = e.preview,
        o = e.image,
        i = e.important,
        s = void 0 !== i && i,
        a = {
      name: n,
      value: t || null,
      preview: r || null,
      image: o || null
    };
    this.send("display", a, s);
  }, e.prototype.reportError = function (e) {
    this.error(e);
  }, e.prototype.use = function (e) {
    var t = this;
    if ("function" != typeof e) throw new Error("plugins must be a function");
    var r = e.bind(this)(this);
    if ("object" != typeof r) throw new Error("plugins must return an object");

    if (r.features) {
      if ("object" != typeof r.features) throw new Error("features must be an object");
      Object.keys(r.features).forEach(function (e) {
        return function (e) {
          var n = r.features[e];
          if ("function" != typeof n) throw new Error("feature " + e + " is not a function");
          if (isReservedFeature(e)) throw new Error("feature " + e + " is a reserved name");
          t[e] = n;
        }(e);
      });
    }

    return this.plugins.push(r), r.onPlugin && "function" == typeof r.onPlugin && r.onPlugin.bind(this)(this), this;
  }, e.prototype.onCustomCommand = function (e, n) {
    var t = this,
        r = {
      id: this.customCommandLatestId,
      command: e,
      handler: n
    };
    return this.customCommandLatestId += 1, this.customCommands.push(r), this.send("customCommand.register", {
      id: r.id,
      command: r.command
    }), function () {
      t.customCommands = t.customCommands.filter(function (e) {
        return e.id !== r.id;
      }), t.send("customCommand.unregister", {
        id: r.id,
        command: r.command
      });
    };
  }, e;
}();

function createClient(e) {
  var n = new Client();
  return n.configure(e), n;
}

exports.corePlugins = corePlugins, exports.Client = Client, exports.createClient = createClient;